<template>
  <div class="player-header">
    <h1>{{ video.title }}</h1>
    <Toggle
      class="toggle"
      :options="['VirtualDirector', 'Free View']"
      store="player.viewMode"
      mutation="setViewMode"
    ></Toggle>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: ["video", "player"],
}
</script>

<style lang="stylus" scoped>
.player-header
  display: flex
  align-items: flex-end
  margin-bottom: 30px
  h1
    fluid font-size 28 20
    font-family: "montserrat"
    font-weight: bold
    color: #001249
    margin: 0px
    @media only screen and (min-width: 950px)
      width: calc(100% - 300px)
  @media screen and (max-width: mobile-landscape)
    margin-bottom: 25px
  .toggle
    margin-left: auto
  @media only screen and (max-width: 950px)
    margin-bottom: 10px
    flex-wrap: wrap
    .toggle
      margin-top: 15px
      display: inline-block
</style>
